import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Modal } from "react-bootstrap";

import { useAuth } from "../../../context/AuthContext";

import { useSelector, useDispatch } from "react-redux";

import { setShow } from "../../../features/modal/ModalSlice";

import './FormStyles.css'



export default function AddProducts() {

    const dispatch = useDispatch()

    const show = useSelector((state) => state.modal.value.show);

    const defaultValue = {
        title: '',
        description: '',
        code: '',
        price: '',
        stock: '',
        image: null,
        category: '',
        subCategory: ''
    }

    const apiURL = process.env.REACT_APP_API_URL;
    const { user, loading } = useAuth();
    const [form, setForm] = useState(defaultValue);
    const [isLoading, setIsLoading] = useState(false)

    const handleChange = (e) => {
        if (e.target.name === 'image') {
            const file = e.target.files ? e.target.files[0] : null
            setForm({ ...form, [e.target.name]: file })
        } else {
            setForm({ ...form, [e.target.name]: e.target.value })
        }
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault()

            const formData = new FormData()

            for (const [key, value] of Object.entries(form)) {
                formData.append(key, value)
            }

            axios
                .post(`${apiURL}/api/products/addproduct/${user.uid}`, formData)
                .then((res) => {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Producto agregado",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    dispatch(setShow(false));
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            alert(error.message)
        }

    }

    return (
        <>

            <Modal show={show} onHide={() => dispatch(setShow(false))}>
                <Modal.Header>
                    <Modal.Title>Agregar Producto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <input
                                type="text"
                                required
                                name="title"
                                placeholder="title"
                                value={form.title}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                required
                                name="description"
                                placeholder="description"
                                value={form.description}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                required
                                name="code"
                                placeholder="code"
                                value={form.code}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                required
                                name="price"
                                placeholder="price"
                                value={form.price}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                required
                                name="stock"
                                placeholder="stock"
                                value={form.stock}
                                onChange={handleChange}
                            />
                            <select
                                required
                                name="category"
                                value={form.category}
                                onChange={handleChange}
                            >
                                <option value="">Selecciona la categoria</option>
                                <option value="Accesorios">Accesorios</option>
                                <option value="AccesoriosCiclista">Accesorios ciclista</option>
                                <option value="Cadenas_cadenillas">Cadenas y cadenillas</option>
                                <option value="Candados">Candados</option>
                                <option value="Cascos">Cascos</option>
                                <option value="Canas">Cañas</option>
                                <option value="Cintas">Cintas y grips</option>
                                <option value="Frenos_pastillas">Frenos y pastillas</option>
                                <option value="Gafas">Gafas</option>
                                <option value="Grupos_componentes">Grupos y componentes</option>
                                <option value="Guantes">Guantes</option>
                                <option value="Herramientas">Herramientas y bombas</option>
                                <option value="Hidratacion">Hidratacion</option>
                                <option value="RodamienHidrataciontos">Hidratacion</option>
                                <option value="Lubricantes">Lubricantes</option>
                                <option value="Luces">Luces</option>
                                <option value="Manzanas">Manzanas</option>
                                <option value="Manubrios">Manubrios</option>
                                <option value="MarcosMTB">Marcos MTB</option>
                                <option value="MarcosFixie">Marcos Fixie</option>
                                <option value="MarcosRuta">Marcos Ruta</option>
                                <option value="Neumáticos">Neumáticos</option>
                                <option value="Pedales">Pedales</option>
                                <option value="Pachas">Pachas</option>
                                <option value="Piñones">Piñones</option>
                                <option value="Postes">Postes</option>
                                <option value="Relaciones">Relaciones</option>
                                <option value="Rines_llantas">Rines y llantas</option>
                                <option value="Rodamientos">Rodamientos</option>
                                <option value="Ropa">Ropa</option>
                                <option value="Sillines">Sillines</option>
                                <option value="Tenedores">Tenedores y Suspensiones</option>
                                <option value="Zapatillas">Zapatillas</option>


                            </select>

                            <input
                                type="file"
                                name="image"
                                placeholder="image"
                                accept='image/png, image/jpeg'
                                onChange={handleChange}
                            />

                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => dispatch(setShow(false))}>
                        Cancelar
                    </Button>
                    <Button type="submit" onClick={handleSubmit}>Crear Producto</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
